import type { BragBarProps as Props } from './types';
import { cls } from '@/utils/cls';
import style from './BragBar.module.scss';
import BragItem from './BragItem';
export default function BragBar({
  extendStyles,
  items,
  alignment = 'space-around',
  separateMobileLayout = false,
  backgroundColor,
  mobileLayout
}: Props) {
  const _className = cls(style.root, extendStyles);
  const hasItems = !!items && items.length > 0;
  const mobileHasItems = !!mobileLayout && mobileLayout.items && mobileLayout.items.length > 0;
  return <aside className={_className} style={{
    backgroundColor: backgroundColor
  }} data-sentry-component="BragBar" data-sentry-source-file="BragBar.tsx">
			<div data-grid>
				<div className={style.content}>
					<div className={cls(style.items, style.desktop)} style={{
          justifyContent: alignment
        }} data-testid="desktop-layout">
						{hasItems && items.map((item, index) => <BragItem key={`brag-item-${index}`} item={item} index={index} />)}
					</div>
					<div className={cls(style.items, style.mobile)} style={{
          justifyContent: mobileLayout?.alignment || alignment
        }} data-testid="mobile-layout">
						{separateMobileLayout && mobileLayout && mobileHasItems && mobileLayout.items.map((item, index) => <BragItem key={`brag-item-${index}`} item={item} index={index} />)}
						{!separateMobileLayout && hasItems && items.map((item, index) => <BragItem key={`brag-item-${index}`} item={item} index={index} />)}
					</div>
				</div>
			</div>
		</aside>;
}